import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faApple,
  faFacebookF,
  faGooglePlay,
  faInstagram,
  faLinkedinIn,
  faWhatsapp,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";
import { Link } from "react-router-dom";
import { Award, Globe2, Star } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useLanguage } from "../../contexts/LanguageContext";
// import wiLogo from "../../assets/images/Wi_logo_transparent.png";
import wiLogo from "../../assets/images/wilearn_W.png";


const footerSections = [
  {
    title: "Wilearn",
    links: [
      { label: "👤 About Us", to: "/about" },
      { label: "💼 Career", to: "/careers" },
      { label: "📰 Press Release", to: "/press-release" },
      { label: "🎓 Alumni Speak", to: "/alumni-speak" },
      { label: "🛟 Grievance Support", to: "/support" },
      { label: "📞 Contact Us", to: "/contact" },
    ],
  },
  {
    title: "Work With Us",
    links: [
      { label: "🎓 Join as Student", to: "/register" },
      { label: "👨‍🏫 Join as Teacher", to: "/trainer-register" },
    ],
  },
  {
    title: "For Businesses",
    links: [
      { label: "💼 Wilearn Internship", to: "/internship" },
      { label: "🏢 Corporate Training", to: "/corporate-training" },
      { label: "🤝 Become a Training Partner", to: "/trainer-register" },
      
    ],
  },

  {
    title: "Follow Us!",
    links: [
      { label: "🎁 Refer & Earn", to: "/refer-and-earn" },
      
      
    ],
  },
];

// const footerSections = [
//   {
//     title: "About",
//     links: [
//       { label: "About Us", to: "/about" },
//       { label: "Careers", to: "/careers" },
//       { label: "Contact Us", to: "/contact" },
//       { label: "Find Courses", to: "/courses" },
//     ],
//   },
//   {
//     title: "LMS",
//     links: [
//       { label: "Download Application", to: "/download-application" },
//       { label: "Refer & Earn", to: "/refer-and-earn" },
//       { label: "Partners", to: "/partners" },
//     ],
//   },
//   {
//     title: "Join With Us",
//     links: [
//       { label: "Join as Student", to: "/register" },
//       { label: "Join as Teacher", to: "/trainer-register" },
//     ],
//   },
//   {
//     title: "Legal & Accessibility",
//     links: [
//       { label: "Accessibility Statement", to: "/accessibility" },
//       { label: "Privacy Policy", to: "/privacy" },
//       { label: "Terms & Conditions", to: "/terms" },
//       { label: "Refund Policy", to: "/cookie-policy" },
//     ],
//   },
// ];

const socialLinks = [
  { href:"https://www.facebook.com/wilearn.official" , label: "Facebook", icon: faFacebookF, className: "from-blue-500 to-indigo-500" },
  { href: "https://www.linkedin.com/company/wilearn-net", label: "LinkedIn", icon: faLinkedinIn, className: "from-sky-500 to-blue-600" },
  { href: "https://www.instagram.com/wilearn.official", label: "Instagram", icon: faInstagram, className: "from-fuchsia-500 via-rose-500 to-amber-400" },
  { href: "https://www.youtube.com/@wilearnofficial", label: "YouTube", icon: faYoutube, className: "from-red-500 to-rose-600" },
  { href: "https://wa.me/", label: "WhatsApp", icon: faWhatsapp, className: "from-emerald-400 to-green-600" },
];

function Footer({ variant = "default" }) {
  const { t } = useTranslation();
  const { language, languages, changeLanguage } = useLanguage();

  const onLanguageChange = (event) => {
    changeLanguage(event.target.value);
  };

  if (variant === "portal") {
    return (
      <footer className="mt-6 overflow-x-hidden border-t border-white/10 bg-[#0b2447] px-4 py-4 text-slate-200">
        <div className="mx-auto flex min-h-20 max-w-7xl flex-col gap-4 lg:flex-row lg:flex-wrap lg:items-center lg:justify-between">
          <Link to="/" className="flex min-w-0 items-center gap-3 text-white no-underline">
            <span className="flex h-12 w-16 shrink-0 items-center justify-center overflow-hidden rounded-xl border border-white/15 bg-white/10">
              <img src={wiLogo} alt={t("WiLearn")} className="h-full w-full object-contain p-1.5" />
            </span>
            <span className="min-w-0">
              <span className="block text-base font-black leading-tight text-white">{t("WiLearn")}</span>
              <span className="block truncate text-[10px] font-bold uppercase tracking-[0.14em] text-cyan-100/80">
                {t("Learning Platform")}
              </span>
            </span>
          </Link>

          <div className="flex min-w-0 flex-wrap items-center justify-start gap-x-3 gap-y-2 text-sm text-slate-300 lg:justify-center">
            <Link to="/privacy" className="font-semibold text-slate-200 no-underline transition hover:text-white">{t("Privacy Policy")}</Link>
            <span className="text-slate-500">|</span>
            <Link to="/terms" className="font-semibold text-slate-200 no-underline transition hover:text-white">{t("Terms")}</Link>
            <span className="text-slate-500">|</span>
            <Link to="/cookie-policy" className="font-semibold text-slate-200 no-underline transition hover:text-white">{t("Refund Policy")}</Link>
          </div>

          <div className="flex flex-wrap items-center gap-2" aria-label={t("Social Links")}>
            {socialLinks.map((item) => (
              <a
                key={item.label}
                href={item.href}
                target="_blank"
                rel="noreferrer"
                aria-label={t(item.label)}
                className={`flex h-9 w-9 items-center justify-center rounded-xl bg-gradient-to-br ${item.className} text-white shadow-sm transition hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-white/70`}
              >
                <FontAwesomeIcon icon={item.icon} />
              </a>
            ))}
          </div>

          <p className="max-w-md text-xs leading-5 text-slate-300 lg:text-right">
            © 2026 <span className="font-semibold text-white">WiLearn</span>. All Rights Reserved.
            <span className="block">Designed &amp; maintained by <span className="font-semibold text-slate-200">MYKARATE LLP</span>.</span>
          </p>
        </div>
      </footer>
    );
  }

  return (
    <footer className="overflow-x-hidden bg-[#0b2447] text-left text-slate-200">
      {/* [#1c1d1f] */}
      <div className="mx-auto grid max-w-7xl grid-cols-[repeat(auto-fit,minmax(180px,1fr))] gap-x-8 gap-y-9 px-5 py-10 lg:px-6">
        {footerSections.map((section) => (
          <nav key={section.title} aria-label={t(section.title)} className="min-w-0">
            <h2 className="text-lg font-bold tracking-wide text-white">
              {t(section.title)}
            </h2>
            <ul className="mt-2 space-y-0">
              {section.links.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    // className="inline-flex min-h-[44px] max-w-full items-center break-words text-medium font-medium text-slate-300 no-underline transition hover:text-white focus:outline-none focus:ring-2 focus:ring-white/70 focus:ring-offset-2 focus:ring-offset-[#1c1d1f]"
                    className={ item.to === "/refer-and-earn"
    ? "inline-flex min-h-[44px] max-w-full items-center rounded-lg border border-violet-300 bg-violet-600/25 px-4 py-2 font-semibold text-white no-underline shadow-md transition hover:bg-violet-600/45 hover:border-violet-200"
    : "inline-flex min-h-[44px] max-w-full items-center break-words text-medium font-medium text-slate-300 no-underline transition hover:text-white focus:outline-none focus:ring-2 focus:ring-white/70 focus:ring-offset-2 focus:ring-offset-[#1c1d1f]"
}
                    //   ${
                    //     section.title === "FOLLOW US!"
                    //       ? "rounded-lg border border-violet-400 bg-violet-600/20 px-5 text-white shadow-sm hover:bg-violet-600/40 hover:border-violet-300"
                    //       : "text-slate-300 hover:text-white"
                    //   }
                    // `}className="inline-flex min-h-[44px] max-w-full items-center break-words text-medium font-medium text-slate-300 no-underline transition hover:text-white focus:outline-none focus:ring-2 focus:ring-white/70 focus:ring-offset-2 focus:ring-offset-[#0b2447]"                  
                  >
                    {t(item.label)}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        ))}
      </div>

      {/* <div className="border-t border-white/10 bg-[radial-gradient(circle_at_12%_20%,rgba(79,70,229,0.28),transparent_30%),radial-gradient(circle_at_86%_18%,rgba(14,165,233,0.22),transparent_28%),linear-gradient(135deg,#08152d_0%,#111827_48%,#24104c_100%)]"> */}
      <div className="border-t border-white/10 bg-[#0b2447]">
        <div className="mx-auto max-w-7xl px-5 py-8 lg:px-6">
          <div className="w-full overflow-hidden rounded-2xl border border-white/12 bg-white/[0.07] p-4 shadow-2xl shadow-indigo-950/30 backdrop-blur-xl sm:p-6">
            <div className="grid gap-6 lg:grid-cols-[minmax(0,1.15fr)_minmax(220px,1fr)] lg:items-center">
              <Link to="/" className="group flex min-w-0 flex-col gap-4 text-white no-underline sm:flex-row sm:items-center">
                <span className="flex h-16 w-24 shrink-0 items-center justify-center overflow-hidden rounded-2xl border border-white/15 bg-white/10 shadow-lg shadow-black/20 transition duration-300 group-hover:-translate-y-1 group-hover:bg-white/15">
                  <img src={wiLogo} alt={t("WiLearn")} className="h-full w-full object-contain p-2" />
                </span>
                <span className="min-w-0">
                  <span className="block text-2xl font-black leading-tight text-white">{t("WiLearn")}</span>
                  <span className="mt-1 block break-words text-xs font-bold uppercase tracking-[0.14em] text-cyan-100/80 sm:tracking-[0.24em]">
                    {t("Learning Platform")}
                  </span>
                  <span className="mt-2 block max-w-md text-sm leading-6 text-slate-200/85">
                    {t("Build skills. Earn credentials. Shape your future.")}
                  </span>
                </span>
              </Link>

             
            {/* Right Side - App Download Buttons */}
                <div className="flex min-w-0 justify-start lg:justify-end">
                  <div className="flex w-full min-w-0 flex-col gap-3 sm:flex-row sm:flex-wrap lg:justify-end">
                    {/* <Link
                      to="/download-application"
	                      className="flex h-14 w-full min-w-0 items-center gap-3 rounded-xl bg-white px-4 text-slate-900 no-underline shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-xl sm:w-auto sm:min-w-48 sm:max-w-full"
                    >
                      <FontAwesomeIcon icon={faApple} className="text-2xl" />
                      <div className="min-w-0 leading-tight">
                        <span className="block text-[10px] font-semibold text-slate-500">
                          {t("Download on the")}
                        </span>
                        <span className="block truncate text-sm font-bold">
                          {t("App Store")}
                        </span>
                      </div>
                    </Link> */}

                    <Link
                      to="/download-application"
                      className="flex h-14 w-full min-w-0 items-center gap-3 rounded-xl bg-white px-4 text-slate-900 no-underline shadow-md transition-all duration-300 hover:-translate-y-1 hover:shadow-xl sm:w-52"
                    >
                      <FontAwesomeIcon
                        icon={faGooglePlay}
                        className="text-2xl text-emerald-500"
                      />
                      <div className="min-w-0 leading-tight">
                        <span className="block text-[10px] font-semibold text-slate-500">
                          {t("Get it on")}
                        </span>
                        <span className="block truncate text-sm font-bold">
                          {t("Google Play")}
                        </span>
                      </div>
                    </Link>
                  </div>
                </div> 
            </div>

	            <div className="mt-6 flex flex-col gap-5 border-t border-white/10 pt-5 xl:flex-row xl:flex-wrap xl:items-center xl:justify-between">
              <div className="flex flex-wrap items-center justify-center gap-3 sm:justify-start" aria-label={t("Social Links")}>
                {socialLinks.map((item) => (
                  <a
                    key={item.label}
                    href={item.href}
                    target="_blank"
                    rel="noreferrer"
                    aria-label={t(item.label)}
                    className={`flex h-11 w-11 items-center justify-center rounded-2xl bg-gradient-to-br ${item.className} text-white shadow-lg shadow-black/20 transition duration-300 hover:-translate-y-1 hover:scale-105 hover:shadow-xl focus:outline-none focus:ring-2 focus:ring-white/70`}
                  >
                    <FontAwesomeIcon icon={item.icon} />
                  </a>
                ))}
              </div>

	              <div className="flex min-w-0 flex-col gap-4 sm:flex-row sm:flex-wrap sm:items-center xl:justify-end">
                <label className="sr-only" htmlFor="footer-language">
                  {t("Language selector")}
                </label>
	                <div className="relative w-full min-w-0 sm:w-auto">
                  <Globe2 className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-cyan-100" size={16} />
                  <select
                    id="footer-language"
                    value={language}
                    onChange={onLanguageChange}
	                    className="h-11 w-full min-w-0 rounded-2xl border border-white/20 bg-white/10 py-2 pl-9 pr-8 text-sm font-semibold text-white outline-none transition hover:bg-white/15 focus:border-white focus:ring-2 focus:ring-white/40 sm:min-w-40 sm:max-w-full"
                  >
                    {languages.map((language) => (
                      <option key={language.code} value={language.code} className="text-slate-900">
                        {language.label}
                      </option>
                    ))}
                  </select>
                </div>

	                <div className="flex min-w-0 flex-wrap items-center gap-x-3 gap-y-2 text-sm text-slate-300">
                  
                  <Link to="/privacy" className="font-semibold text-slate-200 no-underline transition hover:text-white">{t("Privacy Policy")}</Link>
                  <span className="text-slate-500">|</span>
                  <Link to="/terms" className="font-semibold text-slate-200 no-underline transition hover:text-white">{t("Terms")}</Link>
                  {/* <Link to="/sitemap" className="font-semibold text-slate-200 no-underline transition hover:text-white">{t("Sitemap")}</Link> */}
                  <span className="text-slate-500">|</span>
                  <Link to="/cookie-policy" className="font-semibold text-slate-200 no-underline transition hover:text-white">{t("Refund Policy")}</Link>
                </div>
              </div>
            </div>
                        {/* </div> */}

            {/* Copyright & Organization Information */}
            <div className="mt-5 border-t border-white/10 pt-5 text-center">
              <p className="mx-auto max-w-6xl text-xs leading-6 text-slate-300 sm:text-sm">
                © 2026 <span className="font-semibold text-white">WiLearn</span>. All Rights Reserved.
                <span className="mx-2 hidden sm:inline text-slate-500">•</span>
                <span className="block sm:inline">
                  WiLearn is an initiative of the{" "}
                  <span className="font-semibold text-slate-200">
                    World Council of Indigenous Games (WIG)
                  </span>.
                </span>
                <span className="mx-2 hidden sm:inline text-slate-500">•</span>
                <span className="block sm:inline">
                  Designed &amp; maintained by{" "}
                  <span className="font-semibold text-slate-200">
                    MYKARATE LLP
                  </span>.
                </span>
              </p>

              <p className="mt-1 text-[11px] leading-5 text-slate-400 sm:text-xs">
                Content is licensed under Creative Commons Attribution 4.0
                International License (CC BY 4.0).
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
